import "./Login.scss";

import { useState, useEffect } from "react";
import validator from "validator";
import queryString from "query-string";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { IoMdEyeOff, IoMdEye } from "react-icons/io";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import { appVersion } from "../../utils/utils";
import logo from "../../assets/images/logo_lingo.svg";
import ButtonMB from "../../components/Buttons/Button";
import imgOndas1 from "../../assets/images/login/img_ondas/1.png";
import imgOndas2 from "../../assets/images/login/img_ondas/2.png";
import imgOndas3 from "../../assets/images/login/img_ondas/3.png";
import imgOndaBg from "../../assets/images/login/img_ondas/bg.jpg";
import { endLoading, initLoading } from "../../store/slices/generics.slice";
import ChangeLanguageSelect from "../../components/ChangeLanguage/ChangeLanguage";
import { firstLogin, login, sendForgot } from "../../store/middleware/user.middleware";

const bgImgArr = [imgOndas1, imgOndas2, imgOndas3];

function Login({ location }) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");

  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const [setTargetRedirect] = useState("");
  const [password, setPassword] = useState("");
  const [leftImage, setleftImage] = useState("");
  const [dialogMsg, setDialogMsg] = useState("");
  const [isForget, setIsForget] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [errorsForget, setErrorsForget] = useState([]);
  const [emailRecover, setEmailRecover] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(sessionStorage.getItem("@remember") === "N" ? false : true);
  const [email, setEmail] = useState(
    sessionStorage.getItem("@rememberEmail") !== null ? sessionStorage.getItem("@rememberEmail") : "",
  );

  useEffect(() => {
    setleftImage(bgImgArr[Math.round(Math.random() * 2)]);
    const targeturl = queryString.parse(location?.search).target;
    if (targeturl) setTargetRedirect(targeturl);

    if (navigator.userAgent.toLowerCase().indexOf("op") > -1) {
      if (window?.caches) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      } else {
        console.log("Este navegador não suporta a limpeza de cache via JavaScript.");
      }
    } else if (navigator.userAgent.indexOf("MSIE") > -1) {
      if (window?.caches) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      } else {
        console.log("Este navegador não suporta a limpeza de cache via JavaScript.");
      }
    } else if (navigator.userAgent.indexOf("Firefox") > -1) {
      if (window?.caches) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      } else {
        console.log("Este navegador não suporta a limpeza de cache via JavaScript.");
      }
    } else if (navigator.userAgent.indexOf("Epiphany") > -1) {
      if (window?.caches) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      } else {
        console.log("Este navegador não suporta a limpeza de cache via JavaScript.");
      }
    } else if (navigator.userAgent.indexOf("Chrome") > -1) {
      if (window?.caches) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      } else {
        console.log("Este navegador não suporta a limpeza de cache via JavaScript.");
      }
    } else if (navigator.userAgent.indexOf("Safari") > -1) {
      console.log("Using Safari");
    }

    // eslint-disable-next-line
  }, []);

  const changeLanguage = (lng) => i18n.changeLanguage(lng);
  const toggleForget = () => setIsForget(!isForget);

  const toggleShowPassword = (event) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleFormRecover = (e) => {
    e.preventDefault();

    setErrorsForget([
      !validator.isEmpty(emailRecover) ? !validator.isEmail(emailRecover) : validator.isEmpty(emailRecover),
    ]);

    if (!errorsForget[0]) {
      dispatch(sendForgot({ email: emailRecover }))
        .then(() => {
          setOpen(true);
          setDialogTitle("All done!");
          setDialogMsg("Please check your inbox");
          setIsForget(false);
        })
        .catch((err) => {
          setOpen(true);
          setDialogMsg("Error: " + err);
          setDialogTitle(t("ERROR_DIALOG"));
          console.log("Erro Social login: ", err);
        });
    }
  };

  const renderForgetPassword = () => {
    return (
      <div className="forget-pass">
        <div className="form-holder forget-header-holder">
          <div className="forget-header">
            <span>{t("FORGET_TITLE")}</span>
            <CloseIcon style={{ margin: "10px", fontSize: 32, cursor: "pointer" }} onClick={() => toggleForget()} />
          </div>
          <div className="red-line" />
        </div>
        <div className="form-holder">
          <form>
            <label htmlFor="emailrecover" required={errorsForget[0]}>
              {t("EMAIL")}
              <span style={{ fontSize: "0.9em", marginLeft: "5px", color: "var(--color-red)" }}>
                {errorsForget[0] && t("EMAIL_ERROR")}
              </span>
            </label>
            <input
              type="email"
              name="emailrecover"
              value={emailRecover}
              className="input-lingo"
              required={errorsForget[0]}
              placeholder={t("EMAIL_PLACEHOLDER")}
              onChange={(e) => setEmailRecover(e.target.value)}
            />
            <ButtonMB title={t("BTN_SEND")} clickAction={handleFormRecover} />
          </form>
        </div>
      </div>
    );
  };

  const handleForm = (e) => {
    e.preventDefault();
    setErrors([
      !validator.isEmpty(email) ? !validator.isEmail(email) : validator.isEmpty(email),
      validator.isEmpty(password),
    ]);

    if (remember) {
      sessionStorage.setItem("@remember", "S");
    } else {
      sessionStorage.setItem("@remember", "N");
    }

    if (
      [!validator.isEmpty(email) ? !validator.isEmail(email) : validator.isEmpty(email), validator.isEmpty(password)]
        .length > 0
    ) {
      dispatch(initLoading());

      dispatch(login({ strategy: "lingo", email, password }, true))
        .then(async (newData) => {
          await dispatch(firstLogin(newData));
        })
        .catch((err) => {
          setOpen(true);
          setErrors([]);

          if (err.message === "Not Authorized") {
            setDialogMsg(t("PASSWORD_ERROR"));
          } else {
            setDialogMsg("Error " + err.message);
          }

          setDialogTitle(t("ERROR"));
        })
        .finally(() => {
          dispatch(endLoading());
        });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setShowPassword(!showPassword);
      handleForm(e);
    }
  };

  return (
    <div className="containerBox">
      <div className="content-left" style={{ backgroundImage: `url(${imgOndaBg})` }}>
        <img src={logo} className="logo-top" alt="logo" />
        <img src={leftImage} className="img-random" alt="logo" />
      </div>

      <div className="content-right">
        {isForget && renderForgetPassword()}
        {!isForget && (
          <div className="form-holder">
            <div className="form-top">
              <h1 style={{ fontWeight: "100" }}>
                {t("WELCOME_TITLE")}{" "}
                <span style={{ fontWeight: "bold", marginLeft: "12px", color: "var(--color-blue)" }}>Lingo</span>
              </h1>
              <div className="red-line" />
            </div>
            <form>
              <label htmlFor="email" required={errors[0]}>
                {t("EMAIL")}
                <span style={{ fontSize: "0.9em", marginLeft: "5px", color: "var(--color-red)" }}>
                  {errors[0] && t("EMAIL_ERROR")}
                </span>
              </label>
              <input
                name="email"
                type="email"
                tabIndex={1}
                value={email}
                required={errors[0]}
                className="input-lingo"
                placeholder={t("EMAIL_PLACEHOLDER")}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="password">
                {t("PASSWORD")}
                <span
                  style={{
                    fontSize: "0.9em",
                    marginLeft: "5px",
                    color: "var(--color-red)",
                  }}
                >
                  {errors[1] && t("PASS_ERROR")}
                </span>
              </label>
              <div className="input-lingo-div-password">
                <input
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: "90%" }}
                  required={errors[1]}
                  className="input-lingo-password"
                  placeholder={t("PASS_PLACEHOLDER")}
                  type={showPassword ? "text" : "password"}
                  tabIndex={2}
                  onKeyUp={handleKeyPress}
                />
                <span onClick={(e) => toggleShowPassword(e)} className="input-lingo-button-password">
                  {showPassword ? <IoMdEyeOff size={18} /> : <IoMdEye size={18} />}
                </span>
              </div>

              <div className="forgotPassword">
                <div className="switch__container addInput">
                  <input
                    id="switch-shadow10"
                    className="switch switch--shadow checkbox"
                    name="multiLingo"
                    type="checkbox"
                    checked={remember}
                    onChange={() => {
                      setRemember(!remember);
                    }}
                  />
                  <label htmlFor="switch-shadow10">
                    <span>{t("REMEMBER_ACCESS")}</span>
                  </label>
                </div>
                <Button onClick={() => toggleForget()}>{t("FORGOT_PASS")}</Button>
              </div>

              <ButtonMB title={t("BTN_LOGIN")} tabIndex={3} className="btn-login" clickAction={handleForm} />
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexdirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "20px 0",
                  fontWeight: "500",
                  fontFamily: "Quicksand",
                  color: "#707070",
                }}
              >
                <span>{t("NOT_REGISTERED")}</span>

                <a href={t("LINK_SUBSCRIPTION")} target="_blank" rel="noreferrer">
                  <span
                    style={{
                      padding: "5px",
                      color: "red",
                      fontSize: "14px",
                      textDecorationLine: "underline",
                    }}
                  >
                    {t("CHECK_OUR_PLANS")}
                  </span>
                </a>
              </div>
            </form>

            {false && (
              <div className="holder-register">
                {t("NEW_USER")}
                <span>
                  <a
                    href="http://ec2-34-227-25-89.compute-1.amazonaws.com/for-me-pricing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("SIGN_UP")}
                  </a>
                </span>
              </div>
            )}
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span className="language">{t("LANGUAGE")}: </span>
                <ChangeLanguageSelect
                  onChange={(e) => changeLanguage(e.target.value)}
                  value={lang?.split("-")[0] === "pt" ? "pt" : lang?.split("-")[0] === "en" ? "en" : lang}
                />
              </div>

              <span className="versionPlatform">v{appVersion}</span>
            </div>
          </div>
        )}
      </div>

      <Dialog
        open={open}
        keepMounted
        className="boxModal"
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <div className="boxModal">
            <DialogContentText id="alert-dialog-slide-description">
              <span>{dialogMsg}</span>
            </DialogContentText>
          </div>
        </DialogContent>

        <DialogActions>
          <div className="boxModal">
            <Button onClick={() => setOpen(false)} color="primary" autoFocus>
              {t("BTN_CLOSE")}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Login;
